export const TestUnitId = '/7730/OTS_COM/snow/USA_Rock/CO/25';

export const GOOGLE_AD_REFRESH_KEY = 'refresh';
export const GOOGLE_AD_REFRESH_VALUE = 'true';
export const GOOGLE_AD_SECONDS_TO_WAIT_AFTER_VIEWABILITY = 30;
